import React from 'react';
import { CompetencyGroup } from '../../types';
import { useApp } from '../../context/AppContext';
import { useScrollReveal } from '../../hooks/useScrollReveal';
import SectionTitle from '../ui/SectionTitle';
import { Etiqueta, etiqueta } from '../../data/etiquetas';
import './Competencies.css';

interface Props {
  competencies: CompetencyGroup[];
  techStack: Etiqueta[];
}

const Competencies: React.FC<Props> = ({ competencies, techStack }) => {
  const { t, lang } = useApp();
  const ref = useScrollReveal();

  return (
    <section className="competencies" id="competencias">
      <div
        className="competencies__inner reveal-section"
        ref={ref as React.RefObject<HTMLDivElement>}
      >
        <SectionTitle
          eyebrow={lang === 'es' ? 'Áreas de valor' : 'Value areas'}
          title={lang === 'es' ? 'Competencias' : 'Competencies'}
          light
          number="03"
        />

        <div className="competencies__grid">
          {competencies.map((group, i) => (
            <div key={i} className="competency-group">
              <h3 className="competency-group__title">{t(group.groupTitle)}</h3>
              <ul className="competency-group__list">
                {group.items.map((item, j) => (
                  <li key={j} className="competency-group__item">
                    <span className="competency-group__dot" />
                    {t(item)}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Tech Stack */}
        <div className="tech-stack">
          <h3 className="tech-stack__title">
            {lang === 'es' ? 'Stack tecnológico' : 'Technology stack'}
          </h3>
          <div className="tech-stack__tags">
            {techStack.map(tech => (
              <span key={tech} className="tech-stack__tag">{etiqueta(tech, lang)}</span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Competencies;
